// Action types
export const START_LOADER_ACTION = 'connect/ui/loaders/start-action';
export const STOP_LOADER_ACTION = 'connect/ui/loaders/stop-action';
